import { createContext, useContext, useSyncExternalStore } from 'react';
import { useLocation } from 'react-router';
import { isTelegram } from './platform';

/** С этой ширины веб-версия — сайдбар и колонка (`DesktopShell`), а не экран телефона. */
const DESKTOP_QUERY = '(min-width: 1024px)';

function subscribe(onChange: () => void): () => void {
  const query = window.matchMedia(DESKTOP_QUERY);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
}

/**
 * Десктопная раскладка — только в браузере и на широком окне. В Telegram
 * Desktop мини-апп остаётся колонкой телефона: там свой интерфейс клиента
 * вокруг, и наш сайдбар был бы лишним.
 */
export function useDesktopLayout(): boolean {
  const wide = useSyncExternalStore(subscribe, () => window.matchMedia(DESKTOP_QUERY).matches);
  return wide && !isTelegram();
}

/**
 * Страница внутри десктопного каркаса: навигацию держит сайдбар, и нижние
 * табы (`TabBar`) не рисуются.
 */
export const DesktopShellContext = createContext(false);

export function useInDesktopShell(): boolean {
  return useContext(DesktopShellContext);
}

/**
 * Пути, у которых в сайдбаре свой пункт (`DesktopShell`). Это разделы, а не
 * вложенные экраны: «← Назад» на них в каркасе не показывается — с
 * «Настроек» он вёл бы в «Профиль», которого в сайдбаре на компьютере нет.
 */
export const DesktopRootsContext = createContext<ReadonlySet<string>>(new Set());

export function useIsDesktopRoot(): boolean {
  const roots = useContext(DesktopRootsContext);
  const { pathname } = useLocation();
  return useInDesktopShell() && roots.has(pathname);
}
